export default __webpack_public_path__ + "static/media/package-10.59754fed.svg";